<template>
  <div class="manage-team d-card py-3 px-3">
    <div class="d-flex justify-content-between mb-1">
      <p class="d-title mt-2 mb-0" style="font-size: 18px;">Billing Details</p>
    </div>
    <div class="d-flex mb-2 justify-content-between">
      <p class="mb-0 d-desc__m551" style="width: 400px;">Add, edit, and manage your account below.</p>
      <p class="mb-0 d-title__2" style="font-size: 16px;">Monthly Subscription Total : <span class="text-success">${{ (99
        * filteredOffices.length).toFixed(2) }}</span></p>
    </div>
    <!-- for credit card settings and moved from card settings file to here as per client request 12-07-23  -->
    <div class="manage-team mb-3">
      <div class="d-flex justify-content-between mb-1">
        <p class="d-title mt-2 mb-0" style="font-size: 18px;">Update Credit Card</p>
      </div>
      <div class="d-flex mb-4 justify-content-between">
        <p class="mb-0 d-desc__m551" style="width: 400px;">Update your Credit Card Information</p>
        <p class="mb-0 d-title__2" style="font-size: 16px;"> <a href="https://stripe.com/docs/customer-management"
            target="_blank" class="custom-btn btn danger__2 ml-2"> Update </a></p>
      </div>

    </div>
    <div v-for="(ofc, oI) in filteredOffices" :key="oI">
      <div class="dash mb-4" v-if="oI > 0"></div>
      <div class="d-flex justify-content-between align-items-center my-3" v-b-toggle="`ofc-set-${oI}`"
        :ref="`ofc-set-${oI}`" @click="handleAccordionToggle(oI, ofc.name)">
        <p class="mb-2 d-title__2" style="font-size: 16px;">{{ ofc.name }}</p>
        <b-icon icon="chevron-down" class="ml-3"></b-icon>
      </div>
      <b-collapse :id="`ofc-set-${oI}`" accordion="my-accordion" role="tabpanel">
        <div class="notf-surr">
          <div class="check-switch-box mb-2 pl-3 pr-2">
            <div class="notf-p1">
              <p class="mb-0 d-title__4">Ordo Subscription Plan</p>
            </div>
            <div class="ml-auto">
              <div class="sm-card">
                <p class="mb-0 d-desc__3 gilroy-b c-text"><span class="text-success ml-2">$99.00</span></p>
                <b-btn class="custom-btn danger__2 sm-btn ml-4" style="width: max-content"
                  @click="(cancelModal = true)">Contact to Cancel</b-btn>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <modal :modal="billModal" @change="togglebillModal" size="md">
      <div>
        <billing-info :offices="[selectedOfc]" :single="true" @done="togglebillModal" />
      </div>
    </modal>
    <modal :modal="cancelModal" @change="toggleCancelModal" size="md">
      <p class="modal-header-title text-center">Cancel Ordo Subscription</p>
      <div class="d-flex justify-content-center">
        <p class="modal-header-desc text-center mb-4">Please email <a href="mailto:hello@joinordo.com"
            class="text-danger__2">hello@joinordo.com</a> to cancel your Ordo subscription</p>
      </div>
      <div class="dash mb-4"></div>
      <div>
        <p class="c-title__2 mb-1 mt-2 cursor-pointer text-center" @click="(cancelModal = false)">Close</p>
      </div>
    </modal>
  </div>
</template>

<script>
import OfficeMixin from '@/mixins/OfficeMixin'
import BillingInfo from '@/components/onboarding/BillingInfo'
import Modal from '@/components/modals/Modal'
export default {
  mixins: [OfficeMixin],
  components: {
    BillingInfo,
    Modal,
  },
  data: () => ({
    billModal: false,
    selectedOfc: null,
    cancelModal: false,
  }),
  mounted() {
    setTimeout(() => {
      this.$refs[`ofc-set-${0}`][0].click()
    }, 300)
  },
  computed: {
    cardEnd() {
      if (this.office.cc_number && this.office.cc_number.length >= 4) return this.office.cc_number.substr(this.office.cc_number.length - 4)
      return this.office.cc_number
    },
    filteredOffices() {
      return [this.offices[this.officeIndex]].concat(this.offices.filter(o => o.id != this.officeId))
    },
  },
  methods: {
    togglebillModal(v) {
      if (v != this.billModal) this.billModal = v != null ? v : false
    },
    openBillModal(office) {
      this.selectedOfc = office
      this.billModal = true
    },
    toggleCancelModal(v) {
      if (v != this.cancelModal) this.cancelModal = v || false
    },
    handleAccordionToggle(index, officeName, name) {
      this.$emit('accordion-toggle', { index, officeName });
      console.log(index, officeName)
    }
  },
}
</script>

<style lang="sass" scoped>
.custom-btn.danger__2
    display: flex
    align-items: center
    min-height: auto
@import '../../../style/settings'
@import '../../../style/onboarding/onboarding'
</style>